module.exports = __webpack_public_path__ + "static/media/Logo.6b2083a6.svg";